import { useNavigate } from "react-router-dom";
import axios from "axios";
import { generateUsername } from "unique-username-generator";
import { notification } from "antd";
import { __hideLoader, __showLoader } from "../Redux Store/Slices/loader";
import { WebinarUrl } from "../urls";
import { useState } from "react";
import { tempToast } from "../utils/toasts";

const useWebinarForm = () => {
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const handleSubmit = async (values) => {
    tempToast();
    return;

    setloading(true); // Start loading

    const data = {
      // username: generateUsername("-", 2, 20, values.name.split(" ")?.[0]),
      email: values.email,
      phoneNumber: values.phoneNumber,
      name: values.name,
      courseInterest: values.courseOfInterest,
      // role: "STUDENT",
      // birthdate: dob,
      // phone: "+14155552671",
      // password: values.password
    };
    console.log({ values, data });

    try {
      const response = await axios.post(WebinarUrl.register, data);
      api.info({
        message: "Notification",
        description: "Registration successful!",
        duration: 0,
      });
      // console.log("response")
      // console.log(response.data);
      // dispatch(setTokens({
      //     access_token: response.data.accessToken,
      //     refresh_token: response.data.accessToken,
      // }));
      // navigate("/dashboard/")
      // navigate("/otp-verification", { state: { phoneNumber: values.phoneNumber } });
    } catch (error) {
      let errorMessage = "Something Went Wrong";
      if (Array.isArray(error?.response?.data?.message)) {
        errorMessage = error?.response?.data?.message?.join?.(", ");
      } else {
        errorMessage = error?.response?.data?.message;
      }
      api.error({
        message: "Error",
        description: errorMessage,
        duration: 0,
      });
    } finally {
      setloading(false);
    }
  };

  return { handleSubmit, contextHolder, loading };
};

export default useWebinarForm;
